module.exports = __webpack_public_path__ + "static/media/gelach.ab17b88d.mp3";